import { Directive, HostListener, Injector, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';
import { stripEmailSpaces } from './strip-email-spaces';

@Directive({
	selector: '[noSpaces]',
})
export class NoSpacesDirective implements OnInit {
	private ngControl: NgControl | null = null;

	constructor(private injector: Injector) {}

	ngOnInit(): void {
		this.ngControl = this.injector.get(NgControl, null, { self: true });
	}

	@HostListener('keydown', ['$event'])
	onKeyDown(event: KeyboardEvent): void {
		if (event.key === ' ' || event.code === 'Space') {
			event.preventDefault();
		}
	}

	@HostListener('beforeinput', ['$event'])
	onBeforeInput(event: InputEvent): void {
		if (event.inputType === 'insertText' && event.data != null && event.data.length === 1 && /\s/.test(event.data)) {
			event.preventDefault();
		}
	}

	@HostListener('input', ['$event'])
	onInput(event: Event): void {
		const input = event.target as HTMLInputElement | null;
		if (!input || typeof input.value !== 'string') {
			return;
		}
		const cleaned = stripEmailSpaces(input.value);
		if (cleaned === input.value) {
			return;
		}
		const selectionStart = input.selectionStart ?? cleaned.length;
		const beforeCaret = input.value.slice(0, selectionStart);
		const removedBeforeCaret = beforeCaret.length - stripEmailSpaces(beforeCaret).length;
		const nextPos = Math.max(0, selectionStart - removedBeforeCaret);
		input.value = cleaned;
		input.setSelectionRange(nextPos, nextPos);
		const control = this.ngControl?.control;
		if (control && control.value !== cleaned) {
			control.setValue(cleaned);
		}
		input.setSelectionRange(nextPos, nextPos);
	}
}
